import './SpecialDayOffMyRequests.scss';
import { useTranslation } from 'react-i18next';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import {
  getBackgroundColorForStatus,
  infoTabStatus,
  requestlistNoData,
  sdoStatusType
} from './SpecialDayOffHelper';
import AcDialog from '../AcDialog/AcDialog';
import Loader from '../Loader/Loader';
import { IPADVIEWCONSTANTS } from '../SpecialDayOffAdminReport/UsageReportHelper';
import { months } from '../../constants/dates';
import {
  getDateInWeekDayMonthDateFormat,
  getEasternTime
} from '../../helpers/dateHelpers';
import { SdoMyRequest } from '../../models/SdoInterface';
import { useNotifications } from '../../providers/Notifications';
import { useSpecialDayOffProvider } from '../../providers/SpecialDayOffProvider';

export default function SpecialDayOffMyRequests({
  currentPairingMonthData,
  notificationVisible,
  handleEditSpecialDayOffRequest,
  setEditSdoForm,
  setNotificationVisible,
  setToggleSdoFormVisible
}) {
  const notificationsContext = useNotifications();
  const specialDayOffContext = useSpecialDayOffProvider();
  const { t } = useTranslation();

  const [conflictBanner, setConflictBanner] = useState(false);
  const [isIpadView, setIsIpadView] = useState(false);
  const [myRequestData, setMyRequestData] = useState<SdoMyRequest[]>();
  const [open, setOpen] = useState(false);
  const [requestedMonthYear, setRequestedMonthYear] = useState<any>({
    requestedMonth: '',
    requestedYear: ''
  });
  const [sdoExceptionGranted, setSdoExceptionGranted] = useState(false);
  const [sdoStatus, setSdoStatus] = useState('');
  const [searchDate, setSearchDate] = useState({
    year: 0,
    month: '',
    transactionId: 0
  });
  const [selectedRequestId, setSelectedRequestId] = useState('');
  const [showSdoRequestButton, setShowSdoRequestButton] = useState(false);
  const [training, setTraining] = useState('n');

  const searchYear = { year: getEasternTime().getFullYear() };

  useEffect(() => {
    ipadViewSettting();

    window.addEventListener('resize', ipadViewSettting);

    function ipadViewSettting() {
      const { innerWidth } = window;
      setIsIpadView(
        innerWidth <= IPADVIEWCONSTANTS.MAXWIDTH &&
          innerWidth > IPADVIEWCONSTANTS.MINWIDTH
      );
    }

    return () => window.removeEventListener('resize', ipadViewSettting);
  }, []);

  useEffect(() => {
    if (
      !specialDayOffContext?.sdoMyRequestData?.length &&
      !specialDayOffContext?.sdoInfoTabData
    )
      return;
    setMyRequestData(specialDayOffContext.sdoMyRequestData);
    setSdoExceptionGranted(
      specialDayOffContext.sdoInfoTabData?.exemptionFlag === 'Y' ? true : false
    );
    getSdoStatus();
    handleShowApprovedBanner();
    notificationsContext.getNotifications();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    specialDayOffContext.sdoInfoTabData,
    specialDayOffContext.sdoMyRequestData
  ]);

  useEffect(() => {
    if (!myRequestData?.length) return;
    getSdoStatus();
    handleShowApprovedBanner();
    setRequestedMonthYear({
      requestedMonth:
        new Date(
          myRequestData && myRequestData[0]?.requestedFromDt
        ).toLocaleString('en-us', { month: 'long' }) +
        ' ' +
        new Date(
          myRequestData && myRequestData[0]?.requestedFromDt
        ).getFullYear(),
      requestedYear: new Date(
        myRequestData && myRequestData[0]?.requestedFromDt
      ).getFullYear()
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myRequestData]);

  useEffect(() => {
    handleShowSdoRequestButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sdoStatus]);

  useEffect(() => {
    if (!specialDayOffContext.sdoCalendarData) return;
    setTraining(
      specialDayOffContext.sdoCalendarData?.trainingFlag?.toLocaleLowerCase()
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [specialDayOffContext.sdoCalendarData]);

  useEffect(() => {
    getSdoStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [training]);

  //To delete the requested Special Day Off Request
  const deleteSpecialDayOffRequest = async (sdoItem) => {
    const deleteId =
      months[Number(sdoItem?.sdoMonth) - 1] + ' ' + sdoItem?.sdoYear;
    setSelectedRequestId(deleteId);
    setSearchDate({
      year: sdoItem?.sdoYear,
      month: sdoItem?.sdoMonth,
      transactionId: sdoItem?.transactionId
    });
    setOpen(true);
  };

  const getSdoStatus = () => {
    const today = getEasternTime();
    const startDay = specialDayOffContext.sdoInfoTabData?.submissionFromDt;
    const endDay = specialDayOffContext.sdoInfoTabData?.submissionToDt;
    const exemption =
      specialDayOffContext.sdoInfoTabData?.exemptionFlag?.toLocaleLowerCase() ||
      'n';
    const totalApprovedSDOs =
      myRequestData?.filter(
        (sdo) =>
          sdo.sdoYear === specialDayOffContext.sdoInfoTabData.sdoYear &&
          sdo.status === sdoStatusType.APPROVED
      ).length || 0;
    const tabStatus = totalApprovedSDOs >= 2 ? sdoStatusType.APPROVED : '';
    const responseDelayFlag =
      specialDayOffContext.sdoInfoTabData?.responseDelayFlag?.toLocaleLowerCase() ||
      'n';
    switch (true) {
      case training === 'y':
        setSdoStatus(infoTabStatus.closed);
        break;
      case tabStatus === sdoStatusType.APPROVED && exemption === 'n':
        setSdoStatus(infoTabStatus.approved);
        break;
      case tabStatus === sdoStatusType.APPROVED &&
        exemption === 'y' &&
        startDay <= today &&
        today <= endDay:
        setSdoStatus(infoTabStatus.open);
        break;
      case startDay <= today && today <= endDay && responseDelayFlag === 'y':
        setSdoStatus(infoTabStatus.openSoon);
        break;
      case startDay <= today && today <= endDay:
        setSdoStatus(infoTabStatus.open);
        break;
      case startDay > today || today > endDay:
        setSdoStatus(infoTabStatus.openSoon);
        break;
      default:
        setSdoStatus(infoTabStatus.open);
        break;
    }
  };

  // const getStatusMarginTop = (params) => {
  //     if (!params) return;
  //     if(isIpadView){
  //         if (params.status.toUpperCase() === "APPROVED") return ""
  //         else return ""
  //     }else if(params.status.toUpperCase() === "APPROVED")return "";
  //     else return "";
  // }

  const getTwoDigits = (param) => (param < 10 ? '0' + param : param);

  const removeSpecialDayOffRequest = async () => {
    if (!searchDate) {
      return;
    }
    await specialDayOffContext.deleteSdoSubmission(searchDate);
    updateConflictNotificationViewedOnDelete();
    specialDayOffContext.getSdoMyRequestData(searchYear);
    handleClose();
    setShowSdoRequestButton(true);
  };

  const handleClose = () => setOpen(false);

  const handleShowApprovedBanner = () => {
    const today = getEasternTime();
    const sdoYear = specialDayOffContext.sdoInfoTabData?.sdoYear;
    const sdoMonth = specialDayOffContext.sdoInfoTabData?.sdoMonth;
    const startDay = specialDayOffContext.sdoInfoTabData?.submissionFromDt;
    const exemptionFlag =
      specialDayOffContext.sdoInfoTabData?.exemptionFlag?.toLocaleLowerCase() ||
      'n';
    const totalApprovedSDOs =
      myRequestData?.filter(
        (sdo) =>
          sdo.sdoYear === specialDayOffContext.sdoInfoTabData.sdoYear &&
          sdo.status === sdoStatusType.APPROVED
      ).length || 0;
    const tabStatus = totalApprovedSDOs >= 2 ? sdoStatusType.APPROVED : '';
    if (tabStatus === sdoStatusType.APPROVED && exemptionFlag === 'n') {
      setNotificationVisible({ approvedVisible: true, conflictVisible: false });
    }
    if (today >= startDay || exemptionFlag === 'y') {
      setNotificationVisible({
        approvedVisible: false,
        conflictVisible: false
      });
    }
    if (myRequestData) {
      const conflict = myRequestData.some(
        (sdo) =>
          sdo.sdoYear === sdoYear &&
          sdo.sdoMonth === sdoMonth &&
          sdo.status === sdoStatusType.CONFLICT
      );
      if (conflict) {
        setNotificationVisible({
          approvedVisible: false,
          conflictVisible: true
        });
        setConflictBanner(true);
      }
    }
  };

  //To enable or disable the Special Day Off Request button
  const handleShowSdoRequestButton = () => {
    const approvedCount = specialDayOffContext.sdoMyRequestData?.filter(
      (sdo) =>
        sdo.sdoYear === specialDayOffContext.sdoInfoTabData?.sdoYear &&
        sdo.sdoMonth !== specialDayOffContext.sdoInfoTabData?.sdoMonth &&
        sdo.status === sdoStatusType.APPROVED
    ).length;
    const currentSDOs = specialDayOffContext.sdoMyRequestData?.filter(
      (sdo) =>
        sdo.sdoYear === specialDayOffContext.sdoInfoTabData?.sdoYear &&
        sdo.sdoMonth === specialDayOffContext.sdoInfoTabData?.sdoMonth &&
        (sdo.status === sdoStatusType.SUBMITTED ||
          sdo.status === sdoStatusType.CONFLICT)
    ).length;
    const endDay = specialDayOffContext.sdoInfoTabData?.submissionToDt;
    const exemption =
      specialDayOffContext.sdoInfoTabData?.exemptionFlag?.toLocaleLowerCase() ||
      'n';
    const startDay = specialDayOffContext.sdoInfoTabData?.submissionFromDt;
    const today = getEasternTime();
    if (sdoStatus === infoTabStatus.open) {
      // there is no sdo req only
      if (myRequestData?.length === 0) setShowSdoRequestButton(true);
      // for sdo requests in past month and not current sdo month
      else if (
        exemption === 'n' &&
        approvedCount < 2 &&
        approvedCount + currentSDOs < 2
      ) {
        setShowSdoRequestButton(true);
      }
      // for execption flag
      else if (
        exemption === 'y' &&
        myRequestData &&
        myRequestData[0] &&
        myRequestData[0].status !== sdoStatusType.SUBMITTED &&
        myRequestData[0].status !== sdoStatusType.CONFLICT
      ) {
        setShowSdoRequestButton(true);
      } else {
        setShowSdoRequestButton(false);
      }
    } else if (sdoStatus === infoTabStatus.approved) {
      if (
        sdoExceptionGranted &&
        myRequestData &&
        myRequestData[0] &&
        myRequestData[0].status !== sdoStatusType.SUBMITTED &&
        myRequestData[0].status !== sdoStatusType.CONFLICT &&
        startDay <= today &&
        today <= endDay
      )
        setShowSdoRequestButton(true);
    } else {
      setShowSdoRequestButton(false);
    }
  };

  const handleShowSpecialDayOffRequestForm = () => {
    setToggleSdoFormVisible(true);
    setEditSdoForm(false);
  };

  const updateConflictNotificationViewedOnDelete = () => {
    if (!notificationsContext?.notifications?.result) return;
    if (notificationsContext?.notifications?.result?.length >= 1) {
      notificationsContext.notifications.result.forEach((msg) => {
        if (msg.module === 'sdo.conflict') {
          notificationsContext.updateNotificationViewed(
            msg.year,
            msg.month,
            'sdo.conflict',
            msg.notificationId
          );
          setNotificationVisible({
            approvedVisible: false,
            conflictVisible: false
          });
        }
      });
    }
  };

  const removeData = {
    title: t('specialDayOff.SpecialDayOffMyRequests.deleteRequestTitle'),
    description: `${t('specialDayOff.SpecialDayOffMyRequests.deleteRequestText1')} ${selectedRequestId} ${t('specialDayOff.SpecialDayOffMyRequests.deleteRequestText2')}`,
    actionLabel: t('specialDayOff.SpecialDayOffMyRequests.deleteRequestCancel'),
    handleAction: handleClose,
    secondaryActionLabel: t(
      'specialDayOff.SpecialDayOffMyRequests.deleteRequestConfirm'
    ),
    handleSecondaryAction: removeSpecialDayOffRequest
  };

  const sdoRequestsColumns = [
    {
      field: 'requested_on',
      headerName: 'Year',
      width: 80,
      editable: false,
      renderCell: (params) => {
        const year =
          myRequestData && myRequestData.length === 0
            ? specialDayOffContext.sdoInfoTabData?.sdoYear
            : params.row?.sdoYear;
        return (
          <>
            <p style={{ fontWeight: 600 }}>{year || '-'}</p>
          </>
        );
      }
    },
    {
      field: 'requested_from_dt',
      headerName: 'Dates',
      width: isIpadView ? 200 : 285,
      editable: false,
      renderCell: (params) => {
        if (myRequestData && myRequestData.length === 0) {
          return (
            <>
              <p className="sdo-requests__requested-dates-content">
                <span className="sdo-requests__requested-dates">-</span>
              </p>
            </>
          );
        }

        const fromDate = params.row?.requestedFromDt;
        const toDate = params.row?.requestedToDt;
        const duration = params.row?.duration;

        let dateDisplay = '';
        if (fromDate && toDate) {
          dateDisplay =
            getDateInWeekDayMonthDateFormat(new Date(fromDate)) +
            ' - ' +
            getDateInWeekDayMonthDateFormat(new Date(toDate)) +
            ' ';
        } else if (fromDate) {
          dateDisplay =
            getDateInWeekDayMonthDateFormat(new Date(fromDate)) + ' ';
        }

        return (
          <>
            <p className="sdo-requests__requested-dates-content">
              <span className="sdo-requests__requested-dates">
                {dateDisplay || '-'}
              </span>
              {duration ? (
                <span className="sdo-requests__requested-days">
                  ({duration} {duration === 1 ? 'day' : 'days'})
                </span>
              ) : null}
            </p>
          </>
        );
      }
    },
    {
      field: 'requestedOn',
      headerName: 'Requested on',
      width: isIpadView ? 200 : 260,
      editable: false,
      renderCell: (params) => {
        if (myRequestData && myRequestData.length === 0) {
          return (
            <>
              <p>-</p>
            </>
          );
        }

        const requestedOn = params.row?.requestedOn;
        if (!requestedOn) {
          return (
            <>
              <p>-</p>
            </>
          );
        }

        const date = new Date(requestedOn);
        const formattedDate =
          getDateInWeekDayMonthDateFormat(date) +
          ' @ ' +
          getTwoDigits(date.getHours()) +
          ':' +
          getTwoDigits(date.getMinutes()) +
          ' ET';
        return (
          <>
            <p>{formattedDate}</p>
          </>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      width: isIpadView ? 232 : 415,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        if (myRequestData && myRequestData.length === 0) {
          return (
            <>
              <p className="sdo-requests__noRequestListDataStatus">
                {t(
                  'specialDayOff.SpecialDayOffMyRequests.noRequestListDataStatus'
                )}
              </p>
            </>
          );
        }

        const status = params.row?.status;
        const remarks = params.row?.remarks;

        if (!status) {
          return (
            <>
              <p>-</p>
            </>
          );
        }

        return (
          <>
            <div className="sdo-requests__status-content">
              <span
                className="sdo-requests__status"
                style={{
                  backgroundColor: `${getBackgroundColorForStatus(status.toUpperCase())}`
                }}
              >
                {status.toUpperCase()}
              </span>
              {remarks && (
                <p className="sdo-requests__status-reason">{remarks}</p>
              )}
            </div>
          </>
        );
      }
    },
    {
      field: 'actions',
      headerName: ' ',
      width: 245,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (params) => {
        const row = params.row;
        const sdoMonth = row?.sdoMonth;
        const status = row?.status;
        const contextSdoMonth = specialDayOffContext.sdoInfoTabData?.sdoMonth;

        if (!row || !sdoMonth || !status || !contextSdoMonth) {
          return <div style={{ cursor: 'pointer' }}></div>;
        }

        return (
          <div style={{ cursor: 'pointer' }}>
            {/* first checking if the request is from past sdo month then don't provide option to edit/delete */}
            {training === 'n' &&
            sdoMonth === contextSdoMonth &&
            (status === sdoStatusType.SUBMITTED ||
              status === sdoStatusType.CONFLICT) ? (
              <>
                <i
                  className="icon-edit"
                  onClick={(e) => handleEditSpecialDayOffRequest(row)}
                />
                <span
                  className="sdo-requests__actions"
                  onClick={(e) => handleEditSpecialDayOffRequest(row)}
                >
                  {t('specialDayOff.SpecialDayOffMyRequests.edit')}
                </span>
                <i
                  className="icon-trash"
                  onClick={(e) => deleteSpecialDayOffRequest(row)}
                />
                <span
                  className="sdo-requests__actions"
                  onClick={(e) => deleteSpecialDayOffRequest(row)}
                >
                  {t('specialDayOff.SpecialDayOffMyRequests.delete')}
                </span>
              </>
            ) : (
              ''
            )}
          </div>
        );
      }
    }
  ];

  return specialDayOffContext.sdoMyRequestLoading ||
    specialDayOffContext.sdoCalLoading ||
    specialDayOffContext.sdoInfoTabLoading ? (
    <Loader />
  ) : (
    <div className="sdo-requests__container">
      <div className="sdo-requests-header-cntr">
        <span className="sdo-requests__my-request-title">
          {t('specialDayOff.SpecialDayOffMyRequests.myRequest')}
        </span>
        {showSdoRequestButton ? (
          <Button
            className="sdo-requests__request-sdo-button--blue"
            onClick={() => handleShowSpecialDayOffRequestForm()}
          >
            {t('specialDayOff.specialDayOffRequestForm.requestSdo')}
          </Button>
        ) : null}
      </div>

      <AcDialog data={removeData} open={open} onClose={handleClose} />

      {training === 'n' && conflictBanner ? (
        <div className="sdo-requests__conflict-request-notification sdo-request__request-notification">
          <i className="icon-Error-warning" />
          <p>
            {t(
              'specialDayOff.SpecialDayOffMyRequests.conflictSdoNotification',
              { month: requestedMonthYear.requestedMonth }
            )}
          </p>
        </div>
      ) : null}

      {training === 'y' ? (
        <div className="sdo-requests__warning-request-notification sdo-request__request-notification">
          {' '}
          {/* div will be displayed until the end of the training can't close it. */}
          <i className="icon-circle-flight" />
          <p>
            {t('specialDayOff.SpecialDayOffMyRequests.warningSdoNotification')}
          </p>
        </div>
      ) : null}

      {training === 'n' && notificationVisible.approvedVisible ? (
        <div className="sdo-requests__approved-request-notification sdo-request__request-notification">
          {' '}
          {/* div will be displayed until the beginning of the next year, can't close it */}
          <i className="icon-Confirmation-circle-green" />
          <p>
            {t(
              'specialDayOff.SpecialDayOffMyRequests.approvedSdoNotification',
              { year: requestedMonthYear.requestedYear }
            )}
          </p>
        </div>
      ) : null}
      <div className="sdo-requests__table">
        {myRequestData && myRequestData.length > 0 ? (
          <DataGridPro
            autoHeight
            disableColumnMenu
            //disableSelectionOnClick
            //disableExtendRowFullWidth={true}
            rows={myRequestData}
            columns={sdoRequestsColumns}
            rowHeight={isIpadView ? 80 : 52}
            hideFooterPagination
            disableRowSelectionOnClick
          />
        ) : (
          <DataGridPro
            autoHeight
            disableColumnMenu
            //disableSelectionOnClick
            //disableExtendRowFullWidth={true}
            rows={requestlistNoData}
            columns={sdoRequestsColumns}
            hideFooterPagination
            disableRowSelectionOnClick
          />
        )}
      </div>
    </div>
  );
}
